export default function ErrorMessage({message}) {
  return (<>
    <span className="form-text text-danger fs-5">{message}</span>
  </>)
}
